import { createContext, createRef, useContext } from "react";
export const vortexContext = createContext({
  loadingModel: false,
  updatingCanvas: false,
  preview: undefined,
  vortexCanvasRef: createRef(),
  error: undefined
});
export const VortexConsumer = vortexContext.Consumer;
export const useVortexContext = () => {
  const context = useContext(vortexContext);
  if (!context) {
    throw new Error("useVortexContext must be used within a VortexProvider");
  }
  return context;
};